import request from '@/util/guciRequest';

// 鼓词列表
export function getGuCiList(params) {
  return request({
    url: '/gc/drumBallad/ua/list',
    method: 'get',
    params
  });
}
